import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import PopoverIcon from '../../../Popover/PopoverIconDark';
import { fromNullable } from 'maybeasy';

export interface Props {
  content: React.JSX.Element;
  pointerStyle?: string;
}

const PopoverContent: React.FC<Props> = ({ content, pointerStyle }) => (
  <div
    className={clsx(
      'absolute w-60 p-2 bg-gray-700 text-sm z-50 rounded-md mt-[-10px]',
      'shadow-[0px_6px_20px_-2px_rgba(26,26,26,0.14),0px_4px_6px_rgba(26,26,26,0.06)]',
    )}
  >
    <div
      className={clsx('absolute', fromNullable(pointerStyle).getOrElseValue('left-28 top-[-7px]'))}
    >
      <PopoverIcon />
    </div>
    {content}
  </div>
);

export default observer(PopoverContent);
